<template>
  <div class="md-layout md-gutter">
    <md-card v-for="ft in files" :key="ft.id" class="md-layout-item md-size-8">
      <md-card-header>
        <h4>{{ ft.name }}</h4>
      </md-card-header>

      <md-card-content>
        <div v-if="ft.file">
          <md-button @click="showFile(ft.file.file)" class="md-button md-success">Ver</md-button>
          <md-button @click="showModal(ft.file.id)" class="md-button md-primary">Modificar</md-button>
        </div>
        <div v-else>
          <upload-file @change="selectedFile"></upload-file>
          <md-button class="md-button md-warning" @click="uploadFile(ft.id)">Subir</md-button>
        </div>
      </md-card-content>
    </md-card>

    <simple-modal v-if="modification" @close="hideModal" :clickToClose="false">
      <md-card>
        <md-card-header>
          <h2>Modificar archivo</h2>
        </md-card-header>
        <md-card-content>
          <upload-file @change="selectedFile"></upload-file>
          <md-button
            :disabled="selected === null"
            class="md-button md-warning"
            @click="modifyFile"
          >Subir</md-button>
          <md-button @click="hideModal">Cancelar</md-button>
        </md-card-content>
      </md-card>
    </simple-modal>
  </div>
</template>

<script>
import catalogService from "@/services/catalog";
import { assetURL } from "@/utils";
import uploadFile from "./wizard/uploadFile";

export default {
  name: "EditFiles",
  props: {
    providerId: { type: [Number, String] },
    pFiles: { type: Array },
  },
  components: { uploadFile },
  data() {
    return {
      fileTypes: [],
      files: [],
      selected: null,
      modification: false,
      fileId: null,
    };
  },
  mounted() {
    catalogService.fetch("provider_file_types").then((res) => {
      this.fileTypes = res;
      this.buildObject();
    });
  },
  methods: {
    showFile(file) {
      window.open(assetURL(file), (name = "_blank"));
    },
    showModal(fId) {
      this.fileId = fId;
      this.modification = true;
    },
    hideModal() {
      this.fileId = null;
      this.modification = false;
      this.selected = null;
    },
    buildObject() {
      this.fileTypes.forEach((element) => {
        this.$set(element, "file", this.getFile(element.id));
        this.files.push(element);
      });
    },
    getFile(ftId) {
      return this.pFiles.find((f) => {
        return f.file_type.id === ftId;
      });
    },
    selectedFile(f) {
      this.selected = f;
    },
    uploadFile(ftId) {
      if (this.selected === null) {
        this.$alertMessage({ title: "Seleccione un archivo" });
        return;
      }
      let payload = new FormData();
      payload.append("file", this.selected);
      payload.append("file_type", ftId);
      payload.append("provider", this.providerId);

      this.$http
        .post("/catalogs/providers/files/", payload, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          let data = response.data;
          let ft = this.files.find((f) => f.id === ftId);
          ft.file = data;
          this.selected = null;
          this.$successMessage({ title: "Archivo cargado" });
        });
    },
    modifyFile() {
      let payload = new FormData();
      payload.append("file", this.selected);

      this.$http
        .put(`/catalogs/modify_file/${this.fileId}/`, payload)
        .then(({ data }) => {
          let element = this.files.find(
            ({ file = {} }) => file && file.id === data.id
          );
          element.file = data;
          this.$successMessage({ title: "Archivo modificado" });
          this.hideModal();
        })
        .catch(this.$fireErrorResponse);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Providers/editFiles.vue